import axios from 'axios';
import { BasicContactFormRequest } from '../../structures/requests/basicContactForm';
import routes from '../routes';

/**
 * We're not interested in the return off a public form, given the sites'
 * intentional spoofing of positive requests
 * even when one doesn't pass with the spam checker.
 * @param request
 */

const createBasicContactForm = async (
  request: BasicContactFormRequest,
): Promise<void> => {
  await axios
    .post(
      routes.API_BASIC_CONTACT_POST,
      request,
      { headers: { Accept: 'application/json' } },
    );
};

export default createBasicContactForm;
